import tripoolSwapABI from './json/3pool/swap';
import wstETHSwapAbi from './json/wsteth-arbitrum/swap';

import Plain2Basic from './json/factory-v2/Plain2Basic';
import Plain2BasicEMA from './json/factory-v2/Plain2BasicEMA';
import Plain2Balances from './json/factory-v2/Plain2Balances';
import Plain2ETH from './json/factory-v2/Plain2ETH';
import Plain2ETHEMA from './json/factory-v2/Plain2ETHEMA';
import Plain2Optimized from './json/factory-v2/Plain2Optimized';
import Plain3Basic from './json/factory-v2/Plain3Basic';
import Plain3Balances from './json/factory-v2/Plain3Balances';
import Plain3ETH from './json/factory-v2/Plain3ETH';
import Plain3Optimized from './json/factory-v2/Plain3Optimized';
import Plain4Basic from './json/factory-v2/Plain4Basic';
import Plain4Balances from './json/factory-v2/Plain4Balances';
import Plain4ETH from './json/factory-v2/Plain4ETH';
import Plain4Optimized from './json/factory-v2/Plain4Optimized';
import DepositZapFantom from './json/factory-v2/DepositZapFantom';
import MetaUSD from './json/factory-v2/MetaUSD';
import MetaUSDBalances from './json/factory-v2/MetaUSDBalances';
import MetaBTC from './json/factory-v2/MetaBTC';
import MetaBTCBalances from './json/factory-v2/MetaBTCBalances';
import MetaUSDFactoryv216 from './json/factory-v2/MetaUSDFraxusdc';
import MetaUSDBalancesFactoryv216 from './json/factory-v2/MetaUSDBalancesFraxusdc';


const multicall_address = '0x2DC0E2aa608532Da689e89e237dF582B783E552C';

const poolsData = {
    '3pool': {
        swap_abi: tripoolSwapABI,
        N_COINS: 3,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e18, 1e6, 1e6],
        tethered: [false, false, false],
        use_lending: [false, false, false],
        is_plain: [true, true, true],
        swap_address: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        token_address: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        gauge_address: '0x7f90122BF0700F9E7e1F688fe926940E8839F353',
        underlying_coins: [
            '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
            '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
            '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
        ],
        coins: [
            '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
            '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
            '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
        ],
    },
    wsteth: {
        swap_abi: wstETHSwapAbi,
        N_COINS: 2,
        coin_precisions: [1e18, 1e18],
        wrapped_precisions: [1e18, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        has_eth: true,
        swap_address: '0xB90B9B1F91a01Ea22A182CD84C1E22222e39B415',
        token_address: '0xEfDE221f306152971D8e9f181bFe998447975810',
        gauge_address: '0xD53cCBfED6577d8dc82987e766e75E3cb73a8563',
        underlying_coins: [
            '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        ],
        coins: [
            '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        ],
    },
};



const factoryPoolDataSkeleton = {
    swap_abi: tripoolSwapABI,
    N_COINS: 3, // to fill and replace w/ null in skeleton
    coin_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    tethered: [false, false], // to fill and replace w/ null in skeleton
    use_lending: [false, false], // to fill and replace w/ null in skeleton
    is_plain: [true, true], // to fill and replace w/ null in skeleton
    swap_address: '0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA', // to fill and replace w/ null in skeleton
    token_address: '0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA', // to fill and replace w/ null in skeleton
    gauge_address: '0x7f90122BF0700F9E7e1F688fe926940E8839F353', // Fake pool address to prevent old multicalls from reverting
    underlying_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    deposit_abi: DepositZapFantom,
    deposit_address: '0xA79828DF1850E8a3A3064576f380D90aECDD3359',
    is_meta: true,
    base_pool: '3pool', // to fill and replace w/ null in skeleton
    meta_N: 5, // to fill and replace w/ null in skeleton
    meta_precisions: [1e18, 1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_coin_precisions: [1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    meta_coins: [ // to fill and replace w/ null in skeleton
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    all_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    is_factory: true,
    sCurveRewards_abi: undefined,
    sCurveRewards_address: undefined,
    reward_token: undefined,
};



export {
    multicall_address,
    poolsData,
    factoryPoolDataSkeleton,
    Plain2Basic,
    Plain2BasicEMA,
    Plain2Balances,
    Plain2ETH,
    Plain2ETHEMA,
    Plain2Optimized,
    Plain3Basic,
    Plain3Balances,
    Plain3ETH,
    Plain3Optimized,
    Plain4Basic,
    Plain4Balances,
    Plain4ETH,
    Plain4Optimized,
    MetaUSD,
    MetaUSDBalances,
    MetaBTC,
    MetaBTCBalances,
    MetaUSDFactoryv216,
    MetaUSDBalancesFactoryv216,
};
